import type { FetchPartnersQuery } from '@/features/partners/api'
import type { PartnersListSearch } from '@/routes/_protected/$tenantKey/settings/partners/-models'

export function buildFetchPartnersQuery(
  tenantKey: string,
  deps: PartnersListSearch
): FetchPartnersQuery {
  return {
    tenantKey,
    query: {
      ...deps,
      enable: deps.enable ?? undefined,
      type: 'CONTRACTOR'
    }
  }
}
